import React, { ReactChild, ReactNode, useMemo } from 'react'
import { makeStyles } from '@mui/styles'

import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import PlusIcon from '@assets/images/icons/plus2.svg'
import { SIGNER_COLOR_CODES } from '@/redux/ducks/signature/edit'
import ThemeInterface from '@/theme-interface'
import { useAppSelector } from '@/redux/store'
import { getContrastText } from '@/modules/base/helpers/getContrastText'
import RichTooltip from '@/modules/base/components/rich-tooltip/rich-tooltip'

interface SignaturePlacementAddProps {
  type: string,
  icon: ReactNode | string,
  label: string,
  tooltipContent?: ReactChild,
  onAdd: (type: string) => void
}
type StylePropTypes = { signerColor: string, contrastColor: string }
const useStyles = makeStyles((theme: ThemeInterface) => ({
  addButton: ({ signerColor, contrastColor }: StylePropTypes) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: contrastColor,
    backgroundColor: signerColor,
    fontSize: theme.fontSizes.small,
    border: `1px solid ${theme.borderColors.outline}`,
    borderRadius: 4,
    padding: '12px 12px',
    cursor: 'pointer',
    minWidth: 200,
    width: '100%',
  }),
  addLabel: {
    margin: '0px 8px',
    flex: 1,
  },
}), { name: 'SignaturePlacementAdd' })

const SignaturePlacementAdd = (props: SignaturePlacementAddProps) => {
  const { activeSigner } = useAppSelector(state => state.signature.edit)
  const signerColor = activeSigner?.color ?? SIGNER_COLOR_CODES[0]
  const contrastColor = useMemo(() => getContrastText(signerColor), [signerColor])
  const classes = useStyles({ signerColor, contrastColor })
  const { type, label, icon, tooltipContent, onAdd } = props

  return (
    <RichTooltip
      disabled={!tooltipContent}
      content={tooltipContent}
      placement='bottom'>
      <div className={classes.addButton} onClick={() => onAdd(type)}>
        <SVGIcon svg={icon} height="13px" width="13px" fill={contrastColor} />
        <span className={classes.addLabel}>{label}</span>
        <SVGIcon svg={PlusIcon} height="12px" width="12px" fill={contrastColor} />
      </div>
    </RichTooltip>
  )
}

export default SignaturePlacementAdd
